import React, { useState } from "react";
import { Grid, Header, Label, Modal, Menu, Segment, Button } from "semantic-ui-react";
import moment from "moment";
import CatalogLog from "./CatalogLog";
import { isJson } from "utils/json";

const ImportModalLogs = ({ logs, open, close }) => {
	const [activeItem, setActiveItem] = useState(0);

	return (
		<Modal onClose={close} open={open} size="fullscreen">
			<Modal.Header>Résultats des imports du catalogue</Modal.Header>
			<Modal.Content>
				<Grid>
					<Grid.Column width={3}>
						<Menu fluid vertical tabular>
							{logs.map((l, i) => (
								<Menu.Item key={`menu-${i}`} name={`menu-${i}`} active={activeItem === i} onClick={() => setActiveItem(i)}>
									{" "}
									<p>{moment(l.created_at).format("DD/MM/YYYY HH:mm")}</p>
								</Menu.Item>
							))}
						</Menu>
					</Grid.Column>

					<Grid.Column stretched width={13}>
						<Segment>
							{
								<CatalogLog
									log={logs[activeItem].result && isJson(logs[activeItem].result) ? JSON.parse(logs[activeItem].result) : ""}
									user={logs[activeItem].user}
									at={moment(logs[activeItem].created_at)}
								/>
							}
						</Segment>
					</Grid.Column>
				</Grid>
			</Modal.Content>
			<Modal.Actions>
				<Button primary onClick={close}>
					Fermer
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default ImportModalLogs;
